module.exports = __webpack_public_path__ + "font/0509ab09c1b0d2200a4135803c91d6ce.woff2";